// T-282/collettiva — Calendario menù BASE di Bluecoop (pilota), da
// `Bluecoop/TRANSCRIZIONI/menu-estivo-2026.md`. Solo i piatti STAMPATI del menù
// di rotazione: le sostituzioni a mano del giorno NON sono qui (il responsabile
// le applica sul piano). PROVVISORIO finché non arriva il menù autorevole.
//
// Modello: rotazione 4 settimane (slot '1A'|'1B'|'2A'|'2B', calcolata da
// menuSlotForDate). Il PRANZO dipende da settimana+variante; la CENA dipende solo
// dalla settimana (1ªA e 1ªB condividono la cena della 1ª settimana). Indice
// giorno 0..6 = Lunedì..Domenica. I nomi piatto si mappano a runtime sulle
// ricette del tenant per nome (match normalizzato); dove non c'è ricetta, il
// piatto resta come suggerimento testuale che il responsabile collega.
import type { MenuSlot } from '@trackeat/shared';

export interface MenuDay {
  primo: string;
  secondo: string;
  contorno: string;
}

const PRANZO: Record<string, MenuDay[]> = {
  '1A': [
    { primo: 'Pasta alla matriciana', secondo: 'Braciola di maiale alla caprese', contorno: 'Insalata di pomodoro e sedano' },
    { primo: 'Pasta alla boscaiola', secondo: 'Filetto di merluzzo in umido', contorno: 'Patate lesse' },
    { primo: 'Risotto alla pescatora', secondo: 'Bistecca alla pizzaiola', contorno: 'Carote lesse' },
    { primo: 'Trenette al pesto', secondo: 'Pollo alla cacciatora', contorno: "Fagiolini all'olio" },
    { primo: 'Gnocchetti di pasta al pomodoro', secondo: 'Nasello in umido', contorno: 'Insalata mista' },
    { primo: 'Pasta alla bolognese', secondo: 'Insalata di pollo', contorno: 'Patate al forno' },
    { primo: 'Pasta gratinata', secondo: 'Arrosto panato', contorno: 'Insalata verde' },
  ],
  '1B': [
    { primo: 'Minestra di verdure con riso', secondo: 'Arrosto di tacchino', contorno: 'Carote lesse' },
    { primo: 'Passato di verdure', secondo: 'Trancio di salmone al forno', contorno: 'Verdure di stagione al forno' },
    { primo: 'Pasta al pomodoro', secondo: 'Falso magro al forno', contorno: 'Patate al forno' },
    { primo: 'Minestra di patate e zucchine', secondo: 'Petto al forno', contorno: 'Insalata mista' },
    { primo: 'Pasta alle olive verdi', secondo: 'Insalata di mare', contorno: 'Ménage di verdure' },
    { primo: 'Minestra di riso con spinaci', secondo: 'Rollè di tacchino', contorno: 'Insalata verde' },
    { primo: 'Minestra di riso e prezzemolo', secondo: 'Tortino alla pizzaiola', contorno: 'Patate prezzemolate' },
  ],
  '2A': [
    { primo: 'Pasta al sugo', secondo: 'Cotoletta di tacchino', contorno: 'Insalata di pomodoro e sedano' },
    { primo: 'Risotto alla pescatora', secondo: 'Filetto di sogliola', contorno: 'Patate prezzemolate' },
    { primo: 'Pasta alla bolognese', secondo: 'Fettina di manzo ai funghi', contorno: 'Carote lesse' },
    { primo: 'Rigatoni con pomodoro e basilico', secondo: 'Spezzatino di pollo', contorno: 'Insalata mista' },
    { primo: 'Fusilli alla boscaiola', secondo: 'Trancio di spada in umido', contorno: 'Patate lesse' },
    { primo: 'Insalata di riso', secondo: 'Saltimbocca alla romana', contorno: "Fagiolini all'olio" },
    { primo: 'Pasta al forno', secondo: 'Bollito di manzo olio e limone', contorno: 'Insalata di pomodoro e sedano' },
  ],
  '2B': [
    { primo: 'Minestra di patate', secondo: 'Pollo al forno', contorno: 'Patate al forno' },
    { primo: 'Pasta al pomodoro', secondo: 'Insalata di polpo', contorno: 'Verdure di stagione' },
    { primo: 'Minestrone con pastina', secondo: 'Bistecca panata', contorno: 'Insalata verde' },
    { primo: 'Pasta al tonno', secondo: 'Rollè di tacchino', contorno: 'Insalata mista' },
    { primo: 'Minestrone di verdure con riso', secondo: 'Seppioline con piselli', contorno: 'Ménage di verdure' },
    { primo: 'Pasta alla trapanese', secondo: 'Pollo burro e salvia', contorno: 'Insalata mista' },
    { primo: 'Pasta piselli e prosciutto', secondo: 'Arrosto di manzo', contorno: 'Patate prezzemolate' },
  ],
};

const CENA: Record<1 | 2, MenuDay[]> = {
  1: [
    { primo: 'Zuppa di verdure', secondo: 'Spezzatino con piselli', contorno: 'Ménage di verdure' },
    { primo: 'Passato di verdure', secondo: 'Frittata vegetale', contorno: 'Ménage di verdure' },
    { primo: 'Pasta burro e salvia', secondo: 'Prosciutto cotto', contorno: "Fagiolini all'olio" },
    { primo: 'Insalata di pasta', secondo: 'Mozzarella', contorno: 'Radicchio rosso in insalata' },
    { primo: 'Pasta alla trapanese', secondo: 'Petto di vitello arrosto', contorno: 'Insalata mista' },
    { primo: 'Passato di legumi', secondo: 'Emmental', contorno: 'Insalata di pomodoro e sedano' },
    { primo: 'Insalata di riso', secondo: 'Trancio di spada in umido', contorno: 'Carote lesse' },
  ],
  2: [
    { primo: 'Passato di verdure', secondo: 'Mozzarella', contorno: 'Insalata verde' },
    { primo: 'Pasta burro e salvia', secondo: 'Brasato al limone', contorno: 'Ménage di verdure' },
    { primo: 'Pastina in brodo vegetale', secondo: 'Frittata vegetale', contorno: 'Insalata di pomodoro e sedano' },
    { primo: 'Minestrone di verdure con riso', secondo: 'Prosciutto cotto', contorno: 'Radicchio rosso in insalata' },
    { primo: 'Passato di legumi', secondo: 'Formaggio tenero', contorno: "Fagiolini all'olio" },
    { primo: 'Minestrone di zucchine con pasta', secondo: 'Scaloppine al limone', contorno: 'Insalata di pomodoro e sedano' },
    { primo: 'Insalata di pasta', secondo: 'Merluzzo alla livornese', contorno: 'Carote lesse' },
  ],
};

export interface MenuDish {
  category: 'PRIMI' | 'SECONDI' | 'CONTORNI';
  name: string;
}

// I 3 piatti (primo/secondo/contorno) per (slot, giorno, servizio).
// meal: 'pranzo' usa lo slot (settimana+variante); 'cena' usa solo la settimana.
export function bluecoopMenuDishes(
  slot: MenuSlot,
  weekday: number, // 1..7 (lun..dom)
  meal: 'pranzo' | 'cena',
): MenuDish[] {
  const idx = Math.min(Math.max(weekday, 1), 7) - 1;
  const day = meal === 'cena' ? CENA[slot.week]?.[idx] : PRANZO[`${slot.week}${slot.variant}`]?.[idx];
  if (!day) return [];
  return [
    { category: 'PRIMI', name: day.primo },
    { category: 'SECONDI', name: day.secondo },
    { category: 'CONTORNI', name: day.contorno },
  ];
}

// Colazione: non a menù di rotazione (pane/latte/ecc.) → vuoto.
export function hasBluecoopMenu(meal: string): boolean {
  return meal === 'pranzo' || meal === 'cena';
}
